{
  "productDetails": {
    "id": "ID",
    "quantity": "Aantal",
    "productDetails": "Product Details",
    "specification": "Specs",
    "reviews": "Reviews",
    "shipping": "Shipping",
    "share": "Share",
    "showReviews": "Show reviews",
    "noReviews": "No reviews yet",
    "uigArticleNumber": "RF-Artikelnummer",
    "supplierArticleNumber": "Fabrikant-Art.Nr.",
    "uvpPrice": "Adv.prijs",
    "priceMargin": "Marge",
    "ekPrice": "Ink",
    "bestPrice": "Beste prijs",
    "discountName": "Bonus soort",
    "discountMessage": "De Bestprijs bepaling is absvolgt samengesteld",
    "rfuvpPrice": "RINGFOTO UVP"
  },
  "productList": {
    "filterBy": {
      "label": "Filter by",
      "action": "Filter by"
    },
    "appliedFilter": "Applied filter:",
    "showLess": "Minder…",
    "showMore": "meer…",
    "sortByRelevance": "Sort by Relevance",
    "backToTopBtn": "TERUG NAAR BOVEN",
    "showMoreBtn": "SHOW MORE"
  },
  "productFacetNavigation": {
    "filterBy": {
      "label": "Filter by",
      "action": "Filter by"
    },
    "appliedFilter": "Applied filter:",
    "showLess": "Show less...",
    "showMore": "Show more...",
    "sortByRelevance": "Sort by Relevance"
  },
  "productSummary": {
    "id": "ID",
    "showReviews": "Show reviews",
    "share": "Share"
  },
  "productReview": {
    "overallRating": "Overall Rating",
    "reviewTitle": "Review Title",
    "writeYourComments": "Write your comments",
    "rating": "Rating",
    "reviewerName": "Reviewer name (optional)",
    "writeReview": "Write a Review",
    "more": "More",
    "less": "Less",
    "thankYouForReview": "Thank you for the review! Note that reviews may require review before appearing here."
  },
  "addToCart": {
    "itemsAddedToYourCart": "Artikel(en) toegevoegd aan uw winkelwagen",
    "error": "Dit artikel is helaas niet te bestellen en wordt daarom niet in de winkelwagen opgenomen.",
    "itemsIncrementedInYourCart": "Dit artikel zit reeds in uw bestelmandje. De hoeveelheid is bijgewerkt.",
    "items": "items",
    "updatingCart": "Winkelwagen bijwerken...",
    "addToCart": "in winkelwagen",
    "viewCart": "Winkelwagen",
    "proceedToCheckout": "Volgorde",
    "quantity": "Aantal",
    "outOfStock": "Out of stock",
    "inStock": "In stock",
    "selectStyleAndSize": "Select style and size to check stock",
    "removeFromCart": "Remove Product from Cart",
    "closeModal": "Close Modal"
  },
  "TabPanelContainer": {
    "tabs": {
      "ProductDetailsTabComponent": "Productdetails",
      "ProductSpecsTabComponent": "Technische gegevens",
      "ProductReviewsTabComponent": "Beoordelingen",
      "deliveryTab": "Verzenden",
      "ProductDownloadsTabComponent": "Downloaden",
      "ProductVideoTabComponent": "Video-Link",
      "ProductPriceSearchTabComponent": "Prijszoekmachines",
      "ProductNaturalRabattTabComponent": "Naturalrabatt",
      "ProductReferencesTabComponent": "Accessoire",
      "ProductSetsTabComponent": "Set"
    }
  },
  "variant": {
    "style": "Style",
    "selectedStyle": "Selected style",
    "size": "Size",
    "color": "Color",
    "sizeGuideLabel": "Style guide"
  },
  "addToWishList": {
    "add": "Bewaren",
    "remove": "Verwijderen",
    "anonymous": "Merken (Anmelden)"
  },
  "stockNotification": {
    "notifyMe": "NOTIFY ME",
    "stopNotify": "STOP NOTIFICATION",
    "getNotify": "Get notified when this product is available.",
    "getNotifySuffix": "to get notified when this product is available.",
    "activateChannelsPrefix": "To be notified you need to activate the ",
    "channelsLink": "Notification Channels",
    "activateChannelsSuffix": ".",
    "notified": "You will be notified when this product is back in stock.",
    "getNotified": "Get notified when this product is back in stock.",
    "unsubscribeSuccess": "You will not receive back-in-stock notification for this product.",
    "subscriptionDialog": {
      "header": "Out of stock subscription",
      "notifiedPrefix": "You will be notified on:",
      "notifiedSuffix": "as soons as this product is back in stock.",
      "manageChannelsPrefix": "Manage your prefered notification channels at the ",
      "manageChannelsLink": "Notification Preference",
      "manageChannelsSuffix": " page.",
      "manageSubscriptionsPrefix": "You can manage your subscriptions at ",
      "manageSubscriptionsLink": "My Interests",
      "manageSubscriptionsSuffix": " page.",
      "okBtn": "OK",
      "subscribing": "Subscribing you to Out of Stock notifications for this product"
    }
  }
}
